// src/components/BulkActions.js
import React, { useState } from 'react';
import axios from 'axios';

function BulkActions({ 
  selectedIds, 
  onActionComplete, 
  type = 'drivers',
  API_URL 
}) {
  const [isProcessing, setIsProcessing] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [actionType, setActionType] = useState('');
  
  const handleBulkAction = async (action) => {
    if (selectedIds.length === 0) {
      alert('Please select at least one item');
      return;
    }
    
    setActionType(action);
    setShowConfirm(true);
  };
  
  const confirmAction = async () => {
    setIsProcessing(true);
    
    try {
      const token = localStorage.getItem('token');
      const endpoint = type === 'drivers' ? `${API_URL}/bulk-driver-action` : `${API_URL}/bulk-customer-action`;
      
      await axios.post(endpoint, {
        ids: selectedIds,
        action: actionType,
        reason: `${actionType} by admin`
      }, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      
      alert(`✅ ${selectedIds.length} items ${actionType} successfully`);
      setShowConfirm(false);
      onActionComplete();
    } catch (error) {
      alert(`❌ Failed to ${actionType}: ${error.response?.data?.error || error.message}`);
    } finally {
      setIsProcessing(false);
    }
  };
  
  const getActionLabel = (action) => {
    const labels = {
      approve: 'Approve',
      block: 'Block',
      unblock: 'Unblock',
      suspend: 'Suspend',
      terminate: 'Terminate'
    };
    return labels[action] || action;
  };
  
  if (selectedIds.length === 0) {
    return null;
  }
  
  return (
    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
      <span style={{ fontSize: '13px', color: '#64748b' }}>
        {selectedIds.length} selected
      </span>
      
      {type === 'drivers' && (
        <>
          <button
            onClick={() => handleBulkAction('approve')}
            style={{
              padding: '6px 14px',
              backgroundColor: '#10b981',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '12px',
            }}
          >
            ✅ Approve
          </button>
          <button
            onClick={() => handleBulkAction('block')}
            style={{
              padding: '6px 14px',
              backgroundColor: '#f59e0b',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '12px',
            }}
          >
            🚫 Block
          </button>
          <button
            onClick={() => handleBulkAction('unblock')}
            style={{
              padding: '6px 14px',
              backgroundColor: '#10b981',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '12px',
            }}
          >
            🔄 Unblock
          </button>
          <button
            onClick={() => handleBulkAction('terminate')}
            style={{
              padding: '6px 14px',
              backgroundColor: '#dc2626',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '12px',
            }}
          >
            ⚠️ Terminate
          </button>
        </>
      )}
      
      {type === 'customers' && (
        <>
          <button
            onClick={() => handleBulkAction('block')}
            style={{
              padding: '6px 14px',
              backgroundColor: '#ef4444',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '12px',
            }}
          >
            🚫 Block
          </button>
          <button
            onClick={() => handleBulkAction('unblock')}
            style={{
              padding: '6px 14px',
              backgroundColor: '#10b981',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '12px',
            }}
          >
            🔄 Unblock
          </button>
        </>
      )}
      
      {/* Confirmation Modal */}
      {showConfirm && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000,
        }}>
          <div style={{
            backgroundColor: 'white',
            borderRadius: '12px',
            padding: '24px',
            width: '400px',
            maxWidth: '90%',
          }}>
            <h3 style={{ margin: '0 0 12px 0' }}>
              {actionType === 'terminate' ? '⚠️' : '🔄'} Confirm {getActionLabel(actionType)}
            </h3>
            <p>
              Are you sure you want to <strong>{getActionLabel(actionType)}</strong> 
              {' '}<strong>{selectedIds.length}</strong> {type}?
            </p>
            {actionType === 'terminate' && (
              <p style={{ color: '#dc2626', fontWeight: 'bold' }}>
                ⚠️ This action is permanent and cannot be undone!
              </p>
            )}
            <div style={{ display: 'flex', gap: '12px', marginTop: '20px', justifyContent: 'flex-end' }}>
              <button
                onClick={() => setShowConfirm(false)}
                style={{
                  padding: '8px 16px',
                  backgroundColor: '#e2e8f0',
                  border: 'none',
                  borderRadius: '6px',
                  cursor: 'pointer',
                }}
              >
                Cancel
              </button>
              <button
                onClick={confirmAction}
                disabled={isProcessing}
                style={{
                  padding: '8px 16px',
                  backgroundColor: actionType === 'terminate' ? '#dc2626' : '#f97316',
                  color: 'white',
                  border: 'none',
                  borderRadius: '6px',
                  cursor: isProcessing ? 'not-allowed' : 'pointer',
                  opacity: isProcessing ? 0.6 : 1,
                }}
              >
                {isProcessing ? 'Processing...' : `Confirm ${getActionLabel(actionType)}`}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default BulkActions;